import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  file: null,
  uuid: null,
}

const curatorProjectArchive = createSlice({
  name: 'curatorProjectArchive',
  initialState,
  reducers: {
    resetState: () => initialState,
    setFile: (state, { payload }) => {
      state.file = payload.file;
      state.uuid = payload.uuid;
    },
  },
});

export const { setFile } = curatorProjectArchive.actions;
export const curatorProjectArchiveActions = curatorProjectArchive.actions;
export const curatorProjectArchiveReducer = curatorProjectArchive.reducer;
export default curatorProjectArchiveReducer;

export const selectProjectArchive = (state) => state.curatorProjectArchive.file;
export const selectProjectArchiveUuid = (state) => state.curatorProjectArchive.uuid;